import { ajax } from 'rxjs/ajax'
import { catchError } from 'rxjs/operators'

import { IMenu } from 'client/../decl'

import { baseURL, handleError, requestHeader } from './api-routes.common'

export const getMenu = () =>
  ajax<IMenu>({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/options/menu-new`,
  }).pipe(catchError(handleError('getMenu')))

export * from './api-routes-accounts'
export * from './api-routes-admin'
export * from './api-routes-analytics'
export * from './api-routes-auth'
export * from './api-routes-commissions'
export * from './api-routes-customers'
export * from './api-routes-inventory'
export * from './api-routes-invoice'
export * from './api-routes-onboarding'
export * from './api-routes-orders'
export * from './api-routes-payments'
export * from './api-routes-vendors'
export * from './api-routes-planning'
export * from './api-routes.common'
